import { LoaderService } from './../../../shared/loader/loader.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggedInUserDto } from 'src/app/core/interfaces/loggedInUserDto';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { NotificationService } from 'src/app/shared/services/notification-service';
import { BroadcastService } from '../../../shared/services/broadcast.service';
import { ResultsService } from '../Service/results.service';
import { AcknowledgementDialog } from 'src/app/shared/error-messages';
import { Constants } from 'src/app/shared/constants';

@Component({
    selector: 'app-ack-dialog',
    templateUrl: './ack-dialog.component.html',
    styleUrls: ['./ack-dialog.component.scss'],
    standalone: false
})

export class AckDialogComponent implements OnInit {

  @Output() redirectEvent = new EventEmitter();
  UserDetail: LoggedInUserDto;
  userName: any;
  public errorMesage = AcknowledgementDialog.errorMesage;
  public maxLength = AcknowledgementDialog.maxLength;
  public requiredMessage = AcknowledgementDialog.requiredMessage;
  public DialogText = AcknowledgementDialog.DialogText;
  public myModel = true;
  dialog: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<AckDialogComponent>, public broadcastService: BroadcastService,
              private readonly formBuilder: UntypedFormBuilder, private readonly snackbarService: NotificationService,
              @Inject(MAT_DIALOG_DATA) private data, private loader: LoaderService,
              private resultService: ResultsService, private auth: AuthenticationService) {
    this.UserDetail = this.auth.GetLoggedInUserDetails();
  }

  ngOnInit() {
    this.dialog = this.formBuilder.group({
      SignedBy: ['', [Validators.required, Validators.maxLength(152)]],
      Checkbox: ['', [Validators.requiredTrue]]
    });
    this.dialog.get('Checkbox').setValue(true);
    this.dialog.get('Checkbox').updateValueAndValidity();
  }

  UserName() {
    if (this.UserDetail.middleName === null || this.UserDetail.middleName === ' ' || this.UserDetail.middleName === undefined) {
      this.userName = this.UserDetail.firstName + ' ' + this.UserDetail.lastName;
      return this.userName;
    } else {
      this.userName = this.UserDetail.firstName + ' ' + this.UserDetail.middleName + ' ' + this.UserDetail.lastName;
      return this.userName;
    }
  }

  Save() {
    this.loader.show();
    if (this.dialog.valid) {
      this.resultService.acknowledgeResults(this.data.accessionId, this.dialog.get('SignedBy').value).subscribe({
        next: x => {
        if (x === true) {
          this.data.signedBy = this.UserName();
          const now = new Date();
          this.data.signedOn = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));
          this.CloseDialog();
          this.loader.hide();
        }
      },
        error: (errorResponse: HttpErrorResponse) => {
          this.loader.hide();
          this.broadcastService.broadcast(Constants.ACKNOWLEDGEMENT_SAVE_ERROR);
          if (errorResponse.status === 400) {
            if (typeof (errorResponse.error) === typeof ({})
              && new Object(errorResponse.error).hasOwnProperty('errors')
              && typeof (errorResponse.error.errors) === typeof ({})) {
              this.updateValidations(new Object(errorResponse.error.errors));
            }
          } else {
            this.snackbarService.warn(AcknowledgementDialog.Warning);
            this.CloseDialog();
          }
        }});
    }
  }

  forbiddenNameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const signedByName = control.value ? (control.value as string).toLowerCase() : '';
      if ((signedByName.includes(this.UserDetail.firstName.toLowerCase()))
        && (signedByName.includes(this.UserDetail.lastName.toLowerCase()))) {
        return null;
      }
      return { forbiddenName: true };
    };
  }

  updateValidations(errors: object) {
    Object.entries(errors).forEach(O => {
      const Key: string = O[0];
      const Value: string = O[1][0];

      if (Key === 'SignedBy') {
        const control = this.dialog.get(Key);
        if (control) {
          control.setErrors({ [Key]: Value });
          control.markAsTouched();
        }
        return;
      }

      this.snackbarService.warn(Value);
      this.CloseDialog();
    });
  }

  CloseDialog() {
    this.dialogRef.close(false);
  }
}
